module.exports = "/images/Arrow-Big-right.png?3ae00186b228aa774562f321acab4404";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/Arrow-Big-right.png
// module id = I/sC
// module chunks = 1